import React from 'react';
import './footer.styles.scss';

const Footer = () => {
    return(
            <div className='footer-container1'>
                <div className='footer-container-left'>
                    <div className='footer-container-left-title'> &lt; DevIN &gt;</div>
                    
                </div>
                <div className='footer-container-right'>
                <div className='footer-container-right-subtitle'>© 2022 Made with ❤️ in INDIA</div>
                </div>
                    
            </div>
    );
}
export default Footer;